import React from "react";

interface MenuSectionItemProps {
  label: string;
  onClick?: () => void;
}

export const MenuSectionItem: React.FC<MenuSectionItemProps> = ({
  label,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center px-4 p-4 w-full text-left hover:bg-gray-100 transition-colors outline-none"
    >
      <span className="text-sm font-normal text-black">{label}</span>
    </button>
  );
};
